import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-db557100"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "basic-info" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = { class: "info-head df aic jcsb" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "df aic" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title-block" }),
  /*#__PURE__*/_createElementVNode("span", { class: "info-head-title" }, "项目经历")
], -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 添加")
const _hoisted_6 = {
  key: 0,
  class: "no-explist-info"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 暂无项目经历")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("立即添加")
const _hoisted_9 = {
  key: 1,
  class: "form-item-block"
}
const _hoisted_10 = {
  key: 0,
  style: {"display":"flex","flex-wrap":"wrap"}
}
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "delete-action" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 删除该段经历")
const _hoisted_14 = {
  key: 1,
  class: "block-line"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "df jcsb" }
const _hoisted_17 = { style: {"flex":"1"} }
const _hoisted_18 = { class: "card-line-btn-group" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_21 = {
  key: 0,
  class: "block-line"
}
const _hoisted_22 = {
  key: 2,
  style: {"text-align":"right","margin":"10px 15px 20px"}
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("保存")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_v_preview_item = _resolveComponent("v-preview-item")!
  const _component_v_preview = _resolveComponent("v-preview")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.isDialog)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "add-action",
              icon: _ctx.CirclePlus,
              type: "text",
              size: "small",
              onClick: _ctx.addForm
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["icon", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      (
          (!_ctx.detail ||
            !_ctx.detail.projectExpList ||
            _ctx.detail.projectExpList?.length === 0) &&
          _ctx.formData.formArr.length === 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_component_el_button, {
              type: "text",
              onClick: _ctx.addForm
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_el_form, {
              "label-position": "top",
              "label-width": "110px",
              ref: "ruleFormRef",
              model: _ctx.formData,
              inline: true
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.formArr, (form, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    style: {"width":"100%"},
                    key: form.guid
                  }, [
                    (!form.isShowDetail)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "项目名称",
                            prop: 'formArr.' + index + '.projectName',
                            rules: [
                  {
                    required: true,
                    message: '请输入项目名称',
                    trigger: 'blur',
                  },
                ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: form.projectName,
                                "onUpdate:modelValue": ($event: any) => ((form.projectName) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "项目角色",
                            prop: 'formArr.' + index + '.projectRole',
                            rules: [
                  {
                    required: true,
                    message: '请输入项目角色',
                    trigger: ['blur', 'change'],
                  },
                ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: form.projectRole,
                                "onUpdate:modelValue": ($event: any) => ((form.projectRole) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          _createVNode(_component_el_form_item, {
                            required: "",
                            label: "项目时间",
                            prop: 'formArr.' + index + '.daterange',
                            rules: [
                  {
                    required: true,
                    message: '请输入项目周期',
                    trigger: ['blur', 'change'],
                  },
                ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                type: "daterange",
                                modelValue: form.daterange,
                                "onUpdate:modelValue": ($event: any) => ((form.daterange) = $event),
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                format: "YYYY-MM-DD",
                                "value-format": "YYYY-MM-DD"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          _createVNode(_component_el_form_item, {
                            style: {"width":"100%"},
                            label: "项目描述",
                            prop: `formArr.${index}.content`,
                            rules: [
                  {
                    max: 500,
                    message: '最多输入500个字',
                    trigger: ['blur', 'change'],
                  },
                ]
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("textarea", {
                                class: "el-textarea__inner content-textarea",
                                "onUpdate:modelValue": ($event: any) => ((form.content) = $event)
                              }, null, 8, _hoisted_11), [
                                [_vModelText, form.content]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["prop"]),
                          _createElementVNode("div", _hoisted_12, [
                            (!_ctx.isDialog)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  icon: _ctx.Delete,
                                  type: "text",
                                  size: "small",
                                  onClick: ($event: any) => (_ctx.deleteForm(index))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_13
                                  ]),
                                  _: 2
                                }, 1032, ["icon", "onClick"]))
                              : _createCommentVNode("", true),
                            (index !== _ctx.formData.formArr.length - 1)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createVNode(_component_v_preview, {
                            itemTopSpace: "5px",
                            "label-width": "130px",
                            style: {"margin":"0 auto"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_preview_item, {
                                width: "50%",
                                label: "项目名称"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.detail?.projectExpList[index].projectName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_preview_item, {
                                width: "50%",
                                label: "项目角色"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.detail?.projectExpList[index].projectRole), 1),
                                    _createElementVNode("div", _hoisted_18, [
                                      _createVNode(_component_el_button, {
                                        class: "card-line-btn",
                                        icon: _ctx.EditPen,
                                        type: "text",
                                        onClick: ($event: any) => (_ctx.edit(index))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_19
                                        ]),
                                        _: 2
                                      }, 1032, ["icon", "onClick"]),
                                      _createVNode(_component_el_button, {
                                        class: "card-line-btn",
                                        icon: _ctx.Delete,
                                        type: "text",
                                        onClick: ($event: any) => (_ctx.deleteForm(index))
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20
                                        ]),
                                        _: 2
                                      }, 1032, ["icon", "onClick"])
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_preview_item, {
                                width: "50%",
                                label: "项目周期"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$utils.dateFm(
                      _ctx.detail?.projectExpList[index].startDate,
                      "YYYY-MM-DD"
                    )) + " ~ " + _toDisplayString(_ctx.$utils.dateFm(
                      _ctx.detail?.projectExpList[index].endDate,
                      "YYYY-MM-DD"
                    )), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_preview_item, {
                                width: "100%",
                                label: "项目描述",
                                content: _ctx.detail?.projectExpList[index].content,
                                type: "textarea"
                              }, null, 8, ["content"]),
                              (index !== _ctx.formData.formArr.length - 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["model"])
          ])),
      (!_ctx.isBatch || (_ctx.formData.formArr.length > 0 && !_ctx.isAllDetail))
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              class: "submit-btn",
              icon: _ctx.Close,
              type: "primary",
              plain: "",
              onClick: _ctx.closeDialogCpt
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 1
            }, 8, ["icon", "onClick"]),
            _createVNode(_component_el_button, {
              class: "submit-btn",
              type: "primary",
              icon: _ctx.Check,
              loading: _ctx.isLoading,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }, 8, ["icon", "loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}